<template>
  <div class="liquor-detail-header">
    <div class="left"></div>
    <div class="right">
      <div class="name"></div>
      <div class></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LiquorDetailHeader"
};
</script>

<style lang="scss">
.liquor-detail-header {
  .left {
    width: 538px;
    margin-right: 40px;
  }

  .right {
  }
}
</style>